import React, { FC, useMemo } from "react";
import { useId } from "@fluentui/react-hooks";
import { Facts, LoadingOverlay } from "cayo.ui";
import ajax from "@cayo/shared/libs/ajax";
import { bindingsUtils } from "@cayo/shared/scheme/bindings";
import { IFacts } from "../../api/schema.api";

const ODataFacts: FC<Omit<IFacts, "type"> & { externalData?: any }> = ({
  items,
  url,
  externalData,
  ...other
}) => {
  const { isLoading, data } = ajax.useGet(url!, other);
  const factsId = useId("facts");

  const odataItems = useMemo(() => {
    const result = items?.map((item) => {
      const { name, value } = item;

      const resolvedValue =
        value && /^\{.*\}$/.test(value!)
          ? bindingsUtils.resolveExpression(data || externalData, value!)
          : value;

      return { name, value: resolvedValue };
    });

    return result;
  }, [items, data, externalData]);

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return <Facts key={factsId} items={odataItems} />;
};

export default ODataFacts;
